"use client";

import { useEffect, useState, type RefObject } from "react";

/** True once the element comes within `rootMargin` of the viewport. Never flips back. */
export const useInViewOnce = (
  ref: RefObject<Element | null>,
  rootMargin = "0px 0px -15% 0px",
) => {
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element || inView) return;
    if (typeof IntersectionObserver === "undefined") {
      setInView(true);
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { rootMargin },
    );
    observer.observe(element);
    return () => observer.disconnect();
  }, [ref, rootMargin, inView]);

  return inView;
};
